"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Chip_1 = __importDefault(require("../Chip"));
var SearchOptionCard_1 = __importDefault(require("../Search/SearchOptionCard"));
var styles_1 = require("../Search/styles");
var Search_1 = require("../Search/Search");
var styles_2 = require("./styles");
var material_1 = require("@mui/material");
var Autocomplete_1 = __importDefault(require("../Autocomplete"));
var SingleSearch = function (_a) {
    var classes = _a.classes, inputDataTestId = _a["data-testid"], _b = _a.disabled, disabled = _b === void 0 ? false : _b, error = _a.error, filterOptions = _a.filterOptions, helperText = _a.helperText, inputValue = _a.inputValue, loading = _a.loading, onBlur = _a.onBlur, onChange = _a.onChange, onInputChange = _a.onInputChange, options = _a.options, placeholder = _a.placeholder, renderOption = _a.renderOption, style = _a.style, sx = _a.sx, value = _a.value;
    var _c = __read((0, react_1.useState)(options || []), 2), usableOptions = _c[0], setUsableOptions = _c[1];
    var _d = __read((0, react_1.useState)(Array.isArray(value) ? Boolean(value === null || value === void 0 ? void 0 : value.length) : Boolean(value)), 2), hasValue = _d[0], setHasValue = _d[1];
    var _e = __read((0, react_1.useState)(options && (options === null || options === void 0 ? void 0 : options.length) > 0 ? false : true), 2), freeSolo = _e[0], setFreeSolo = _e[1];
    var isInputDisabled = (0, react_1.useMemo)(function () {
        if (value) {
            return Array.isArray(value) ? Boolean(value === null || value === void 0 ? void 0 : value.length) : Boolean(value);
        }
        return hasValue;
    }, [hasValue, value]);
    (0, react_1.useEffect)(function () {
        setUsableOptions(options || []);
    }, [options]);
    var actualValue = function () {
        if (value && !Array.isArray(value)) {
            return [value];
        }
        else {
            return value;
        }
    };
    return (react_1.default.createElement(Autocomplete_1.default, { filterOptions: function (options) {
            if (filterOptions) {
                return filterOptions(options);
            }
            else {
                return options;
            }
        }, id: "search-input", onChange: function (event, value, reason) {
            var hasArrayValue = Boolean(value === null || value === void 0 ? void 0 : value.length);
            setHasValue(hasArrayValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(event, value[0], reason);
            if (reason === 'selectOption') {
                setUsableOptions([]);
                setFreeSolo(false);
            }
        }, onInputChange: onInputChange, value: actualValue() || [], inputValue: inputValue, getOptionLabel: (0, Search_1.getIdentityProperty)('getOptionLabel'), multiple: true, classes: classes, freeSolo: freeSolo, sx: __assign({ '& .MuiFilledInput-root': {
                paddingTop: '0px',
            } }, sx), style: style, options: usableOptions, disabled: disabled, PopperComponent: function (props) { return (react_1.default.createElement(material_1.Popper, __assign({}, props, { placement: "bottom", modifiers: [{ name: 'flip', enabled: false }] }))); }, renderTags: function (options, getTagProps) {
            return options.map(function (option, index) { return (react_1.default.createElement(Chip_1.default, __assign({ label: (0, Search_1.getIdentityProperty)('renderTags')(option) }, getTagProps({ index: index })))); });
        }, renderOption: function (props, option) {
            if (renderOption) {
                return renderOption(props, option);
            }
            else
                return (react_1.default.createElement(SearchOptionCard_1.default, __assign({}, props, { avatarUrl: (0, Search_1.getIdentityProperty)('renderOption')(option, 'avatarUrl'), showAvatar: true, subTitle: (0, Search_1.getIdentityProperty)('renderOption')(option, 'buName'), title: (0, Search_1.getIdentityProperty)('renderOption')(option) })));
        }, PaperComponent: styles_1.CustomPaper, renderInput: function (props) { return (react_1.default.createElement(styles_2.FullWidthTextField, { error: error, helperText: helperText, placeholder: isInputDisabled ? '' : placeholder, onBlur: function (e) {
                if (onBlur) {
                    onBlur(e);
                }
                setFreeSolo(true);
                setUsableOptions([]);
            }, InputProps: (0, styles_1.getSearchInputStyles)(disabled, props, loading), inputProps: __assign(__assign({}, props.inputProps), { 'data-testid': inputDataTestId, tabIndex: isInputDisabled ? -1 : 0, readOnly: disabled ? disabled : isInputDisabled, 'aria-hidden': disabled ? disabled : isInputDisabled, onKeyDown: function (e) {
                    if (e.key === 'Enter' && ((options === null || options === void 0 ? void 0 : options.length) === 0 || loading)) {
                        e.stopPropagation();
                    }
                } }) })); } }));
};
exports.default = SingleSearch;
//# sourceMappingURL=SingleSearch.js.map